









































import _ from 'lodash';
import { Component, Vue, Prop } from 'vue-property-decorator';
import InNameToolBox from '@/components/ColumnToolBox/InNameToolBox/index.vue';
import { RawLocation } from 'vue-router';
import {Dictionary, Location} from 'vue-router/types/router.d';
@Component<NameColumn>({
    name: 'NameColumn',
    components: {
        InNameToolBox,
    },
})
export default class NameColumn extends Vue {
    @Prop({ required: true, type: String }) private prop!: string;
    @Prop({ required: true, type: String }) private label!: string;
    @Prop({ type: String, default: 'left' }) private align!: string;
    @Prop({ type: [String, Number], default: '' }) private width!: number | string;
    @Prop({ type: [String, Number], default: 210 }) private minWidth!: number | string;
    @Prop({ type: [Boolean, String], default: false }) private sortable!: boolean | string;

    @Prop({ type: String, default: 'name' }) private name!: string;
    @Prop({ type: String, default: 'id' }) private id!: string;
    @Prop({ type: String, default: 'customID' }) private customID!: string;
    @Prop({ type: Boolean, default: true}) private tools!: boolean;
    @Prop({ type: String, default: ''}) private target!: string;

    @Prop({ type: Object, default: () => {}}) private paramToAdd!: {
        campaignID?: boolean | string;
        adsetID?: boolean | string;
        adID?: boolean | string;
    };
    @Prop({ type: Object, required: true}) private to!: RawLocation
    @Prop({ type: String, default: '' }) private edit!: string;
    @Prop({ type: String, default: '' }) private history!: string;

    @Prop({ type: Array, default: () => (['수정', '복사', '히스토리'])}) private whichTools!: string[];

    @Prop({ type: Function, default: () => {} }) private duplicate!: (row: any) => any;
    @Prop({ type: Function, default: (scope: any, to: string, isCtrlPressed: boolean) => true })
    private linkHandle!: (scope: any, to: RawLocation, isCtrlPressed: boolean) => boolean;

    private TO: RawLocation = this.to;

    private makeTo (scope: any) {
        if (typeof(this.to) === 'string') {
            return _.cloneDeep(this.to);
        }
        const par = this.paramToAdd as {
            campaignID?: string;
            adsetID?: string;
            adID?: string;
        }

        const res = _.cloneDeep(this.to) as Location;
        if (Object.keys(par).length) {
            res.params = {} as {[key: string]: string};
            const params = res.params as {[key: string]: string}
            Object.entries(par).forEach( (value: [string, string | undefined]) => {
                const k = value[0];
                const v = value[1] as string;
                params[k] = scope.row[v];
            })
        }
        return res;
    }
    private method(isCtrlPressed: boolean, scope: any) {
        const to = this.makeTo(scope);
        this.linkHandle(scope, to, isCtrlPressed);
    }
    private editHandle(isCtrlPressed: boolean, to: RawLocation, scope: any) {
        this.linkHandle(scope, to, isCtrlPressed);
    }
    private historyHandle(isCtrlPressed: boolean, to: RawLocation, scope: any) {
        this.linkHandle(scope, to, isCtrlPressed);
    }

    private copyToClipboard(e: Event) {
        const content = (e.target as any).innerText;
        if (window.navigator) {
            if (window.navigator.clipboard) {
                window.navigator.clipboard.writeText(content)
                .then(() => {
                    this.$notify.success('Copied!');
                })
                .catch((err)=> {
                    this.$notify.error('Copy Failed.');
                })
                return;
            }
        }
        const input = window.document.createElement('input') as HTMLInputElement;
        input.value = content; 
        (e.target as any).appendChild(input);
        (input as any).select();
        const isDone = document.execCommand('copy');
        (input as any).blur();
        (e.target as any).innerHTML = content;
        if (isDone) {
            this.$notify.success('Copied!');
        } else {
            this.$notify.error('Copy Failed.');
        }
    }
}
